export const MAXIMUM_COMMENTS_THRESHOLD = 500000;
